import { assetsBasePart } from "./constants";

export default {
  byId: (id: string) => `${assetsBasePart}/projects/${id}`,
  all: () => `${assetsBasePart}/projects`,
  questions: (id: string) => `${assetsBasePart}/projects/${id}/questions`,
  members: (id: string) => `${assetsBasePart}/projects/${id}/members`,
  memberStatus: (id: string) =>
    `${assetsBasePart}/projects/${id}/members/status`,
  status: (id: string) => `${assetsBasePart}/projects/${id}/status`,
  cancel: (id: string) => `${assetsBasePart}/projects/${id}/cancel`,
  update: (id: string) => `${assetsBasePart}/projects/${id}`,
  delete: (id: string) => `${assetsBasePart}/projects/${id}`,
  summary: (id: string) => `${assetsBasePart}/projects/${id}/summary`,
  membersById: (projectId: string, memberId: string) =>
    `${assetsBasePart}/projects/${projectId}/members/${memberId}`,
  projectTemplates: () => `${assetsBasePart}/project-templates`,
  projectTemplateByName: (name: string) =>
    `${assetsBasePart}/project-templates/${name}`,
};
